export const USUARIOS_EMPRESAS_PERMITIDOS: string[] = [
  '230093',
  '242450',
  '242671',
  '237444'
  
];

export function podeAcessarEmpresas(userId: string | number): boolean {
  return USUARIOS_EMPRESAS_PERMITIDOS.includes(String(userId));
}
